import { useEffect, useState } from "react";
import { getBleedBalance } from "@/Api/bleeds";
import { usePermissions } from "@/hooks/usePermissions";
import { TypeUser } from "@/types/userType";

// Cache por sessão da página para não consultar a API a cada filtro montado
let cachedUserId: number | null = null;
let cachedValue: boolean | null = null;
let pending: Promise<boolean> | null = null;

/**
 * Indica se o usuário logado deve ver a forma de pagamento "Dinheiro - Sangria" nos filtros.
 * Admin e dono do tenant sempre veem; os demais usuários só veem se a unidade deles usa sangria.
 * Retorna null enquanto carrega.
 */
export function useCanSeeBleedPaymentForm(): boolean | null {
  const { user } = usePermissions();
  const userId = user?.id ?? null;
  const alwaysSees =
    user?.user_type_id === TypeUser.admin || user?.user_type_id === TypeUser.client;

  const [canSee, setCanSee] = useState<boolean | null>(
    cachedUserId === userId ? cachedValue : null
  );

  useEffect(() => {
    if (!userId || alwaysSees) return;

    if (cachedUserId === userId && cachedValue !== null) {
      setCanSee(cachedValue);
      return;
    }

    if (cachedUserId !== userId || !pending) {
      cachedUserId = userId;
      cachedValue = null;
      pending = getBleedBalance()
        .then(({ data, ok }) => (ok ? !!data?.response?.user_has_bleed : false))
        .catch(() => false)
        .then((value) => {
          cachedValue = value;
          return value;
        });
    }

    let active = true;
    pending.then((value) => active && setCanSee(value));
    return () => {
      active = false;
    };
  }, [userId, alwaysSees]);

  if (!user) return null;
  return alwaysSees ? true : canSee;
}
